module.exports = __webpack_public_path__ + "static/media/bin_1.ab6b45ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bin_1.png
// module id = 893
// module chunks = 0